import React, { useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import AWS from 'aws-sdk'
//import { Auth } from 'aws-amplify'
import { Alert } from 'react-bootstrap'
import { AuthContext } from '../../lib/auth'

export default () => {
  const history = useHistory()

  const auth = useContext(AuthContext)

  const signout = () => {
    auth.signOut()
      .then(() => {
        const identityPoolId = process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID as string
        const credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: identityPoolId
        })

        AWS.config.region = process.env.REACT_APP_AWS_REGION as string
        AWS.config.credentials = credentials

        const sts = new AWS.STS()
        sts.getCallerIdentity({}, (err: any, data: any) => {
          if (err) {
            sts.getCallerIdentity({}, (err: any, data: any) => {
              if (err) {
                console.log(err)
              }
              else console.log(data.Arn)
            })
          }
          else console.log(data.Arn)
        })
      })
  }

  useEffect(() => {
    signout()
    setTimeout(() => {
      history.push('/')
    }, 1000)
    // eslint-disable-next-line
  }, [])

  return (
    <React.Fragment>
      <Alert variant="primary">ログアウトしました</Alert>
      <p className="text-muted">Go to the Top</p>
    </React.Fragment>
  )
}
